import { t } from '@lingui/core/macro';

import { Page } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import PixelCreateContent from './PixelCreateContent';

const PixelCreate = () => {
  return (
    <Page title={t`Create New Pixel`} exampleAIQuestions={exampleAIQuestions('pixel')}>
      <PixelCreateContent />
    </Page>
  );
};

export default PixelCreate;
